import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { PlugsCheckerTaskState } from './state';

const defaultState: PlugsCheckerTaskState = {
  tasks: [],
};

export const plugsCheckerTaskModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
